import { render, staticRenderFns } from "./Cadastrar-agendamento.vue?vue&type=template&id=6e848e47&scoped=true&"
import script from "./Cadastrar-agendamento.vue?vue&type=script&lang=js&"
export * from "./Cadastrar-agendamento.vue?vue&type=script&lang=js&"
import style0 from "./Cadastrar-agendamento.vue?vue&type=style&index=0&id=6e848e47&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e848e47",
  null
  
)

export default component.exports